import { render, staticRenderFns } from "./ContabilitaDocumentiEditPage.vue?vue&type=template&id=9241f382&scoped=true"
import script from "./ContabilitaDocumentiEditPage.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentiEditPage.vue?vue&type=script&lang=js"
import style0 from "./ContabilitaDocumentiEditPage.vue?vue&type=style&index=0&id=9241f382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9241f382",
  null
  
)

export default component.exports